import React from 'react';
import { cn } from '../utils/cn';
import { DeleteOutlined, EditOutlined } from '@mui/icons-material';

const ItemParam = ({ title, value, classContainer }) => {
  return (
    <div className={cn('rounded-2xl bg-gray-200 px-4 py-2 flex-1', classContainer)}>
      <p>{title}</p>
      <p className={'text-base font-semibold pt-1'}>{value}</p>
    </div>
  );
};

const ItemChannel = ({ channel, deleteHandler, editHandler }) => {
  const isSensor = channel?.type.key === 'sensor';
  const buttons = [
    { title: 'редактировать', onHandler: () => editHandler(channel?.input_number), icon: <EditOutlined className="text-orange-500" /> },
    { title: 'удалить', onHandler: () => deleteHandler(channel?.input_number), icon: <DeleteOutlined className="text-orange-500" /> },
  ];

  return (
    <div className="relative rounded-3xl px-5 pt-1 mx-2 sm:mx-8 pb-4 border border-gray-200 mb-4 bg-white">
      <p className={'text-sm text-gray-500'}>Канал №{channel?.input_number}</p>
      <div className={cn('flex justify-between items-center pb-2', !isSensor && 'border-b border-gray-200')}>
        <p className={'text-base'}>{channel?.serial_number}</p>
        <div className={'flex gap-x-2 items-center'}>
          {buttons.map((button, i) => {
            return (
              <button key={button?.title} onClick={button?.onHandler} className={'flex rounded-full bg-gray-100 hover:bg-gray-300 transition-colors p-1'}>
                {button.icon}
              </button>
            );
          })}
        </div>
      </div>
      {!isSensor ? (
        <div className="flex pt-2 gap-x-2">
          <ItemParam classContainer={'mr-3'} title="Коэффицент" value={channel?.modifiers?.multiplier} />
          <ItemParam title="Нач. значение" value={`${channel?.modifiers?.add} л`} />
        </div>
      ) : null}
    </div>
  );
};

const ListChannels = ({ data, deleteHandler, editHandler }) => {
  return data.map((channel) => {
    return <ItemChannel key={channel?.serial_number} channel={channel} deleteHandler={deleteHandler} editHandler={editHandler} />;
  });
};

export default ListChannels;
